const HAS_SEEN_WELCOME_KEY = 'has-seen-welcome';
const HAS_SEEN_POI_TOUR_KEY = 'has-seen-poi-tour';
const HAS_SEEN_HEATMAP_TOUR_KEY = 'has-seen-heatmap-tour';
const LAST_VIEW_KEY = 'last-view';
const EXTENDED_VIRTUAL_TOUR_KEY = 'extended-virtual-tour-status';

export const getHasSeenWelcome = (): boolean =>
  localStorage.getItem(HAS_SEEN_WELCOME_KEY) === 'true';

export const setHasSeenWelcome = (value: boolean) =>
  localStorage.setItem(HAS_SEEN_WELCOME_KEY, String(value));

export const getHasSeenPoiTour = (): boolean =>
  localStorage.getItem(HAS_SEEN_POI_TOUR_KEY) === 'true';

export const setHasSeenPoiTour = (value: boolean) =>
  localStorage.setItem(HAS_SEEN_POI_TOUR_KEY, String(value));

export const getHasSeenHeatmapTour = (): boolean =>
  localStorage.getItem(HAS_SEEN_HEATMAP_TOUR_KEY) === 'true';

export const setHasSeenHeatmapTour = (value: boolean) =>
  localStorage.setItem(HAS_SEEN_HEATMAP_TOUR_KEY, String(value));

export const getLastView = (): 'poi' | 'heatmap' | null =>
  localStorage.getItem(LAST_VIEW_KEY) as 'poi' | 'heatmap' | null;

export const setLastView = (view: 'poi' | 'heatmap') =>
  localStorage.setItem(LAST_VIEW_KEY, view);

export const getExtendedVirtualTourStatusFromLocalStorage = (): string[] => {
  const localStorageValue = localStorage.getItem(EXTENDED_VIRTUAL_TOUR_KEY);
  return localStorageValue ? JSON.parse(localStorageValue) : [];
};

export const setExtendedVirtualTourStatusFromLocalStorage = (
  status: string[],
) => localStorage.setItem(EXTENDED_VIRTUAL_TOUR_KEY, JSON.stringify(status));
